import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

import fondo from '../../assets/img/landingPage/fondo.png';

import icon_free2 from '../../assets/img/landingPage/devStudio/dev-s_01_project.svg'
import icon_dyn2 from '../../assets/img/landingPage/devStudio/dev-s_02_code.svg'
import icon_expo2  from '../../assets/img/landingPage/devStudio/dev-s_03_brunix.svg'


import features_1 from '../../assets/img/landingPage/devStudio/DevStudio_01.png'
import features_2 from '../../assets/img/landingPage/devStudio/DevStudio-02.png'
import features_3 from '../../assets/img/landingPage/devStudio/DevStudio-03.png'

import ReactGA from 'react-ga4'


import logo from '../../assets/img/logos/AVAP_DS_white.svg'

import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

/*Extensiones MVSC*/
import tablet_img from '../../assets/img/landingPage/extensions/Head_Captura_Extensiones.png';

import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'

import features_ex_1 from '../../assets/img/landingPage/extensions/APILifecycle_0.5.png';
import features_ex_2 from '../../assets/img/landingPage/extensions/SeamlessIntegration_0.5.png';
import features_ex_3 from '../../assets/img/landingPage/extensions/DevStudioMVSC-03.png';

import logo2 from '../../assets/img/logos/extensions_white.svg';

/*Extensiones Capturas*/
import extension_one from '../../assets/img/landingPage/extensions/Extensions_01.png';
import extension_two from '../../assets/img/landingPage/extensions/Extensions_02.png';
import extension_three from '../../assets/img/landingPage/extensions/Extensions_03.png';
import extension_four from '../../assets/img/landingPage/extensions/Extensions_04.png';
import extension_five from '../../assets/img/landingPage/extensions/Extensions_05.png';
import extension_six from '../../assets/img/landingPage/extensions/Extensions_06.png';
import extension_seven from '../../assets/img/landingPage/extensions/Extensions_07.png';

import avap_img from '../../assets/img/landingPage/extension-avap@2x.png';
import devstudio_img from '../../assets/img/landingPage/extension-dev@2x.png';
import publisher_img from '../../assets/img/landingPage/extension-publisher@2x.png';
import specs_img from '../../assets/img/landingPage/extension-specs@2x.png';
import version_img from '../../assets/img/landingPage/extension-version@2x.png';
import zero_img from '../../assets/img/landingPage/extension-Zero@2x.png';
import debugger_img from '../../assets/img/landingPage/extension-debbuger@2x.png';


const IdeProduct = () => {

    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-MQZQJN7TQL');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: 'Avap Framework Dev Studio' });
            }

    }, [])

    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-MQZQJN7TQL');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: 'Avap Framework Dev Studio' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {
	
		document.body.classList.add('dark-bg');
		return () => {
			document.body.classList.remove('dark-bg');
		};

	}, []);

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }} >
                
                {/* Titulo Section */}
                <section id="heroProduct" 
                className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo AVAP Dev Studio"
                        className="img-fluid logo"
                    />
                    <h1 className="fl-title m-0">Collaborative IDE for API Development</h1>
                    <p className="fl-subtitle">
                    A Powerful Platform for Next-Gen API <br /> Development and Collaboration
                    </p>
                    <a className="glowBtn-dark fakeHide" href="#"><span className="btnInner">  Start with AVAP Cloud</span></a>
                </section>

                {/* Subtítulo descripción */}
                <section className="container text-center pb-5">
                    <div className="row">
                        <div className="col">

                            {/* <img
                                src="https://placehold.co/1026x423"
                                alt="Platform Placeholder"
                                className="img-fluid mt-4 mb-5"
                            /> */}
                            <p className="fl-subtitle-xs mb-3">
                            A Powerful Platform for Next-Gen API Development and Collaboration


                            </p>

                            <p className="fl-text">
                                AVAP Dev Studio is a powerful IDE that takes advantage of the full capabilities of AVAP technology. It streamlines API creation, management, and optimization with real-time code editing, intelligent error detection, and dynamic testing. Designed for collaboration and ease of use, AVAP Dev Studio accelerates development workflows, boosts productivity, and ensures smooth API lifecycle management.
                            </p>
                        </div>
                    </div>

                </section>

                {/* Features */}
                <section className="container pb-5">
                    <div className="row">
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_free2} alt="Icon of a checklist representing complete project management." />
                               
                                <p>Complete Project Management</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_dyn2} alt="Icon representing AVAP code execution." />
                              
                                <p>AVAP Code Execution</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_expo2} alt="Icon representing AI with BRUNIX Copilot." />
                              
                                <p>BRUNIX Copilot</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Key Feature 01 */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 text-center">
                            <img
                                src={features_1}
                                alt="Illustration of AVAP code assisted by BRUNIX Copilot, showing API publication."
                                className="img-fluid"
                                style={{ height: '400px' }}
                            />
                        </div>
                        <div className="col-md-6 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Complete API Support</h3>
                            <p className="fl-text">
                                Streamline the creation and management of AVAP code repositories while efficiently overseeing the publication of API versions across diverse environments. Simplify the process of managing and controlling unit testing, ensuring seamless deployment across all stages.

                            </p>
                        </div>
                    </div>
                </section>

                {/* Key Feature 02 */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">
                
                        <div className="col-md-6 pl-5">
                        <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Multi-language Support</h3>
                            <p className="fl-text">
                                AVAP Dev Studio provides advanced linters and intelligent code completions for AVAP and the most popular programming languages. It also features an integrated GIT service for efficient API management and seamless GitHub integration, streamlining your development workflow.
                            </p>
                        </div>

                        <div className="col-md-6 text-center">
                            <img
                                src={features_2}
                                alt="Logos of programming languages symbolizing AVAP’s Dev Studio universal compatibility"
                                className="img-fluid"
                            />
                        </div>
                    </div>
                </section>

                {/* Key Feature 03 */}  
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 text-center">
                            <img
                                src={features_3}
                                alt="Terminal window showing AVAP code being assisted by Brunix AI"
                                className="img-fluid"
                            />
                        </div>


                        <div className="col-md-6 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">AI Integration</h3>
                            <p className="fl-text">
                                BRUNIX AI brings advanced artificial intelligence into your development environment, offering real-time code analysis, insights, and modifications to streamline your workflow. Its integrated no-code/low-code tool simplifies complex development tasks, making them accessible to users of all skill levels.
                            </p>
                        </div>

                    </div>
                </section>

                {/* Key Benefits */}
                <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                    API Lifecycle Management
                                </p>
                                <p className="fl-text">
                                    A single environment to efficiently manage API creation, publication, and maintenance, enhancing control and reducing time-to-market.
                                    <br />
                                    &nbsp;
                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                    Visual API Creation for Enhanced Productivity
                                </p>
                                <p className="fl-text">
                                    The integrated visual API design tools accelerate development and improve design accuracy, enabling developers to bring ideas to life quickly and effectively.
                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                    AI-Driven Pre-Development Efficiency
                                </p>
                                <p className="fl-text">
                                    Embedded BRUNIX assists in code translation and real-time analysis, helping developers write more accurate and efficient code based on their input, reducing errors and saving time.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Hero Section Extensions*/}
                <section id="extensionSection" className="text-center"> 
                    <img
                        src={logo2}
                        alt="AVAP API Extensions"
                        className="img-fluid logo"
                    />
                    {/* <h1  className="fl-title m-0">/* THE ALGORITHM THAT PROVES 1+1 IS NOT 2  </h1> */}
                    <p className="fl-subtitle pt-6">
                        Empowering developers to use AVAP within their <br /> preferred development environment
                    </p>
                </section>

                {/* Subtítulo descripción Extensions*/}
                <section className="text-center pt-5 container">
                    <div className="row">
                        <div className="col">
                            {/*<img
                                src={tablet_img}
                                alt="Platform Placeholder"
                                className="img-fluid mt-4 mb-4"
                             />*/}
                            <h3 className="fl-subtitle-xs"><br /><br />Unlock Seamless API Development</h3>
                            <p className="fl-text">
                                AVAP Dev Studio Extensions are powerful tools designed to seamlessly integrate AVAP programming
                                language into Microsoft Visual Code. By leveraging AVAP extensions, developers can efficiently build, test,
                                and manage Virtual APIs within their familiar coding workspace while taking full advantage of the language’s
                                specialized features tailored for API development.
                            </p>
                            <a className="glowBtn-dark " style={{zIndex: 2}} href="https://marketplace.visualstudio.com/search?term=avap&target=VSCode&category=All%20categories&sortBy=Relevance" target='_blank'><span className="btnInner">  AVAP DEV STUDIO EXTENSIONS</span></a>
                        </div>
                    </div>
                </section>

                {/* Extensions */}
                <section className="container mb-5">
                    <div className="row">
                        <div className="col">
                            <div className="fl-title text-center pt-10">Extensions</div>
                        </div>
                    </div>

                    <div className="row pt-6">
                        <div className="col-md-4 order-last order-md-first">
                            <div className="fl-card grayGradient">
                                <img
                                    src={extension_one}
                                    alt="Platform Placeholder"
                                    className="img-fluid "
                                />
                            </div>
                        </div>
                        <div className="col-md-8 order-first order-md-last">
                            <div className='fl-card grayGradient'>
                                <div className="fl-wrapper-label">
                                    <img className='labelImg' src={devstudio_img} alt="dev Studio" />
                                </div>
                                <div className="fl-text">
                                    Core extension for managing your AVAP development workspace. Connect to your AVAP ID, configure environments, and organize users, projects, and teams from Visual Studio Code,
                                    your starting point for building with AVAP.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-8">
                            <div className='fl-card grayGradient'>
                                <div className="fl-wrapper-label">
                                    <img className='labelImg' src={version_img} alt="version control" />
                                </div>
                                <div className="fl-text">
                                    This extension allows you to create code repositories, manage code evolution, and track deployed versions across environments for efficient version control and seamless development.
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                <img src={extension_two} alt="extension two" className="img-fluid " />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 order-last order-md-first">
                            <div className="fl-card grayGradient">
                                <img src={extension_three} alt="extension three" className="img-fluid " />
                            </div>
                        </div>
                        <div className="col-md-8 order-first order-md-last">
                            <div className='fl-card grayGradient'>
                                <div className="fl-wrapper-label">
                                    <img className='labelImg' src={publisher_img} alt="Publisher" />
                                </div>
                                <div className="fl-text">
                                    It integrates seamlessly with other extensions in the AVAP Dev family, enabling the releasing of APIs developed in the AVAP language. It also supports the releasing of APIs created in other technologies with an endpoint. AVAP Dev Extension for Visual Studio Code is required.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-8">
                            <div className='fl-card grayGradient'>
                                <div className="fl-wrapper-label">
                                    <img className='labelImg' src={avap_img} alt="Avap" />
                                    <div className="fl-subtitle">
                                        AVAP Linter & Completion
                                    </div>
                                </div>
                                <div className="fl-text">
                                    A Visual Studio Code extension with rich
                                    support for AVAP language, providing access points for extensions to seamlessly integrate and provide a
                                    complete API lifecycle management, formatting, linting, code navigation, and more.
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                <img src={extension_four} alt="extension four" className="img-fluid " />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 order-last order-md-first">
                            <div className="fl-card grayGradient">
                                <img src={extension_five} alt="extension five" className="img-fluid " />
                            </div>
                        </div>
                        <div className="col-md-8 order-first order-md-last">
                            <div className='fl-card grayGradient'>
                                <div className="fl-wrapper-label">
                                    <img className='labelImg' src={specs_img} alt="Specs" />
                                </div>
                                <div className="fl-text">
                                    This extension simplifies publishing and managing API specifications.
                                    In collaboration with the Open API Initiative, this extension allows developers to effortlessly work with the OpenAPI Specification (OAS),
                                    streamlining API documentation within their IDE.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-8">
                            <div className='fl-card grayGradient'>
                                <div className="fl-wrapper-label">
                                    <img className='labelImg' src={debugger_img} alt="AVAP Debugger" />
                                    <div className="fl-subtitle">

                                    </div>
                                </div>
                                <div className="fl-text">
                                    It delivers a seamless debugging experience, enabling developers to set breakpoints, step through AVAP code, inspect variables, and analyze execution flow with precision. Designed for efficiency, it streamlines troubleshooting and enhances the debugging process within the AVAP development environment.
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                <img src={extension_six} alt="AVAP Debugger Image" className="img-fluid " />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 order-last order-md-first">
                            <div className="fl-card grayGradient">
                                <img src={extension_seven} alt="AVAP Zero Image" className="img-fluid " />
                            </div>
                        </div>
                        <div className="col-md-8 order-first order-md-last">
                            <div className='fl-card grayGradient'>
                                <div className="fl-wrapper-label">
                                    <img className='labelImg' src={zero_img} alt="AVAP Zero" />
                                    <div className="fl-subtitle">

                                    </div>
                                </div>
                                <div className="fl-text">
                                    The AVAP Zero Extension for MVSC empowers developers to build, deploy, and manage APIs effortlessly. Using a no-code interface powered by Brunix, Gen AI, it streamlines API creation and optimization directly within Visual Studio Code for faster, scalable solutions.
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Getting Started */}
                <div className="bottomWrapper position-relative d-flex justify-content-center">
                    <img src={gradientbottom} alt="" className="gradient gradientBottom" />
                </div>
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default IdeProduct;
